<div class="social-dialog">
  <h2 class="social-dialog-recording-title" mat-dialog-title>Set Recording Name</h2>
  <mat-dialog-content class="social-dialog-content">
    <div class="social-dialog-content-text">You will find the recording under this name on your downloads</div>
    <div class="social-dialog-form-container" [formGroup]="formGroup">
      <mat-form-field hideRequiredMarker="true">
        <input
          matInput
          placeholder="Recording name"
          arial-label="Recording name"
          formControlName="name"
          required
          class="social-dialog-input"
        />
        <mat-error>Recording name is required</mat-error>
      </mat-form-field>
    </div>
    <div class="social-dialog-footer">
      <button (click)="cancelButtonClicked()" class="social-dialog-recording-cancel">Cancel</button>
      <button
        data-testid="-modal-dialog-primary-button"
        mat-raised-button
        [disabled]="!formGroup?.valid"
        (click)="confirmButtonClicked()"
        class="social-dialog-recording-primary-button"
      >
        Start Recording
      </button>
    </div>
  </mat-dialog-content>
</div>
